import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWishlist } from '../context/WishlistContext';
import ProductCard from '../components/ProductCard';
import { HiOutlineHeart } from 'react-icons/hi';

const Wishlist = () => {
  const { t } = useTranslation();
  const { wishlist, loading } = useWishlist();
  const wishlistItems = wishlist?.products || [];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div className="animate-fade-in">
      {/* Hero */}
      <section className="bg-primary-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-4xl md:text-5xl mb-4">{t('wishlist.myWishlist')}</h1>
          <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
            <Link to="/" className="hover:text-luxury-gold transition-colors">Home</Link>
            <span>/</span>
            <Link to="/account" className="hover:text-luxury-gold transition-colors">Account</Link>
            <span>/</span>
            <span>Wishlist</span>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {wishlistItems.length === 0 ? (
            <div className="text-center py-16">
              <HiOutlineHeart className="w-20 h-20 mx-auto text-gray-300 mb-6" />
              <h2 className="font-serif text-2xl mb-4">{t('wishlist.emptyWishlist')}</h2>
              <p className="text-gray-500 mb-8">{t('wishlist.emptyWishlistDesc')}</p>
              <Link
                to="/shop"
                className="inline-block bg-luxury-charcoal text-white px-10 py-4 text-sm uppercase tracking-widest hover:bg-gray-800 transition-colors"
              >
                {t('wishlist.exploreProducts')}
              </Link>
            </div>
          ) : (
            <>
              <p className="text-gray-500 mb-8">
                {t('wishlist.itemsInWishlist', { count: wishlistItems.length })}
              </p>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
                {wishlistItems.map((item) => (
                  item.product && <ProductCard key={item._id} product={item.product} />
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default Wishlist;
